/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import settings from "@savchukoleksii/shopify-theme-settings-tool";
import objects from "../../core/objects";
import mapFilters from "../filters/mapFilters";

import {
	onWishlistLoad,
	removeFromWishList,
} from "../../core/helpers/swym";

const modifiers = {
	hidden: "hidden",
	wishlist: {
		added: "button--wishlist-added"
	}
};

const __vue_script__ = {
	name: 'ProductCard',
	props: {
		product: {
			type: Object,
			required: true
		},
		currentVariant: {
			type: Object,
			required: false
		},
		inlineStyle: {
		  type: Boolean,
		  required: false
		}
	},
	data: () => {
		return {
			first_available_variant: null
		};
	},
	created() {
		this.first_available_variant = this.getFirstAvailableVariant()
	},
	mounted() {
		this.initWishlist();
	},
	computed: {
		current_variant() {
			if (!this.currentVariant) {
				return this.first_available_variant;
			}

			return this.currentVariant;
		},
		has_only_default_variant() {
			return this.product.has_only_default_variant;
		},
		featured_image() {
			let image = this.product.featured_image;
			if (!this.current_variant || !this.current_variant.featured_image) {
				return image;
			}

			return this.current_variant.featured_image;
		},
		product_url() {
			if (!this.current_variant) {
				return this.product.url;
			}

			return this.current_variant.url;
		},
		placeholder_image() {
			return settings.get("placeholder_image");
		},
		is_customizable_product() {
			return this.product.template_suffix === "customizable-product";
		},
		product_options() {
			let options = [];

			for (let i = 0; i < this.product.options_with_values.length; i++) {
				options.push({
					title: this.product.options_with_values[i].name,
					value: this.current_variant.options[i]
				})
			}

			return options;
		},
		vendor() {
			return this.link_to_vendor(this.product.vendor, "product-card__vendor");
		},
		has_sale() {
			return this.current_variant.compare_at_price > this.current_variant.price;
		},
		money_format() {
			return objects.get("shop.money_format");
		},
		enable_wishlist() {
			return settings.get("enable_wishlist");
		},
		isAddToCartDisabled() {
			return this.product_availability === 'out_of_stock'
		},
		product_availability() {
		  if (this.current_variant.available) {
			if (this.current_variant.inventory_policy === 'continue' || this.current_variant.inventory_quantity > 3) {
			  return 'in_stock'
			} else if (this.current_variant.inventory_quantity > 0) {
			  return 'runs_out'
			}
		  } else {
			return 'out_of_stock'
		  }
		}
	},
	methods: {
		...mapFilters([
			"file_img_url",
			"money",
			"link_to_vendor"
		]),
		getFirstAvailableVariant() {
			const first_available_variant = this.product.variants.find(variant => variant.available);

			if (first_available_variant) {
				return first_available_variant;
			}

			return this.product.variants[0];
		},
		setCurrentVariant(id) {
			const variant = this.product.variants.find(variant => variant.id === id);

			if (!variant) {
				return;
			}

			this.current_variant = variant;
		},
		product_option_name(option) {
			let optionName = option.value.replaceAll('[hidden]', '');
			let editionVariants = window.editionVariants;
			if (editionVariants) {
				editionVariants = editionVariants.split(',');
				for (let i = 0; i < editionVariants.length; i++) {
					let editionOption = editionVariants[i].trim();
					if (optionName.includes(editionOption)) {
						optionName = optionName.replace(editionOption, '');
					}
				}
			}

			return optionName;
		},
		initWishlist() {
			const wishlistButton = this.$refs.wishlistButton;

			if (!wishlistButton) {
				return null;
			}

			onWishlistLoad(async () => {
				wishlistButton.classList.remove(modifiers.hidden);
			});
		},
		async removeFromWishlist(product, current_variant) {
			await removeFromWishList(product, current_variant);
		},
		async addToCart() {

			let formData = {
				items: [
					{
						id: this.current_variant.id,
						quantity: 1
					},
				],
			};
			let response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			})
				.then((response) => response.json())
				.catch((error) => console.error("Error add to card:", error));
			if (response) {
				const openMiniCartEvent = new Event("openMiniCart");
				document.dispatchEvent(openMiniCartEvent);
			}
		}
	}
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-card",
      class: { "product-card--inline": _vm.inlineStyle },
    },
    [
      _c("div", { staticClass: "product-card__content" }, [
        _vm.enable_wishlist && !_vm.inlineStyle
          ? _c(
              "button",
              {
                ref: "wishlistButton",
                staticClass: "button--wishlist button--wishlist-added",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.removeFromWishlist(
                      _vm.product,
                      _vm.current_variant
                    )
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "icon icon-heart",
                    attrs: {
                      viewBox: "0 0 29 29",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M25.103 1.996c-5.322-3.51-10.644 4.172-10.644 4.172S9.137-1.513 3.816 1.996c-7.012 4.636-.25 17.416 10.643 25.959C25.353 19.412 32.115 6.632 25.103 1.996z",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-miterlimit": "10",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "product-card__media" }, [
          _c(
            "a",
            {
              staticClass: "product-card__image-wrapper",
              attrs: { href: _vm.product_url },
            },
            [
              _c("picture", [
                _vm.featured_image.src
                  ? _c("img", {
                      staticClass: "product-card__image",
                      attrs: {
                        src: _vm._f("img_url")(_vm.featured_image.src, "880x"),
                        alt: _vm.featured_image.alt || _vm.product.title,
                      },
                    })
                  : _c("img", {
                      staticClass: "product-card__image",
                      attrs: {
                        src: _vm._f("img_url")(_vm.placeholder_image, "880x"),
                        alt: _vm.product.title,
                      },
                    }),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "product-card__meta" }, [
          _c(
            "a",
            {
              staticClass: "product-card__title",
              attrs: { href: _vm.product_url },
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(_vm.product.title) + "\n\t\t\t")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "product-card__price" }, [
            _c(
              "span",
              {
                class: {
                  "product-card__price-value": true,
                  "product-card__price-value--compare-price": true,
                  hidden: !_vm.has_sale,
                },
                attrs: { "data-compare-price": "" },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("money")(
                        _vm.current_variant.compare_at_price,
                        _vm.money_format
                      )
                    ) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: {
                  "product-card__price-value": true,
                  "product-card__price-value--sale": _vm.has_sale,
                },
                attrs: { "data-product-price": "" },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("money")(
                        _vm.current_variant.price,
                        _vm.money_format
                      )
                    ) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.product_options.length
            ? _c("div", { staticClass: "product-card__options" }, [
                _c("p", { staticClass: "product-card-options__title" }, [
                  _vm._v(
                    _vm._s(_vm._f("t")("general.wishlist.individualization"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "product-card-options__list" },
                  _vm._l(_vm.product_options, function (option, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "product-card-options__item" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(option.title) +
                              ": " +
                              _vm._s(_vm.product_option_name(option))
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "product-card__status" }, [
            _c(
              "span",
              {
                staticClass: "state-success",
                class: { hidden: this.product_availability !== "in_stock" },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm._f("t")("general.product_available.in_stock")) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "state-danger",
                class: { hidden: this.product_availability !== "runs_out" },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm._f("t")("general.product_available.runs_out")) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "state-error",
                class: { hidden: this.product_availability !== "out_of_stock" },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("t")("general.product_available.out_of_stock")
                    ) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.is_customizable_product
        ? _c("div", { staticClass: "product-card__actions" }, [
            _c(
              "button",
              {
                staticClass: "button",
                class: {
                  "button--primary": _vm.inlineStyle,
                  "button--secondary": !_vm.inlineStyle,
                  disabled: this.product_availability === "out_of_stock",
                },
                attrs: { disabled: _vm.isAddToCartDisabled },
                on: {
                  click: function ($event) {
                    return _vm.addToCart()
                  },
                },
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("t")("general.product_labels.add_to_card")) +
                    "\n\t\t"
                ),
              ]
            ),
          ])
        : _c("div", { staticClass: "product-card__actions" }, [
            _c(
              "a",
              {
                class: {
                  button: true,
                  "button--primary": _vm.inlineStyle,
                  "button--secondary": !_vm.inlineStyle,
                },
                attrs: { href: _vm.product_url },
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("t")("general.wishlist.open_product_page")) +
                    "\n\t\t"
                ),
              ]
            ),
          ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "assets-extend/js/vue/components/ProductCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__